import { cn } from '@hrms/ui';

/** A thin bar in the learning progress tokens — the same accent as the ring and the card edges
 *  (PLAN §10 "Progress language"). */
export function LearningProgressBar({
  percent,
  label,
  className,
}: {
  percent: number;
  label: string;
  className?: string;
}) {
  const value = Number.isFinite(percent) ? Math.min(100, Math.max(0, percent)) : 0;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuenow={Math.round(value)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('h-1.5 w-full overflow-hidden rounded-full bg-progress-track', className)}
    >
      <div
        className="h-full rounded-full bg-progress-fill transition-[width] duration-500 ease-out motion-reduce:transition-none"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
